const chatExecutorDocExists = {
    title: 'Внимание!',
    description: 'Документ имеет загруженный файл. Уверены, что хотите <b>заменить</b> его?',
    buttonText: 'Заменить',
} as const;

export default chatExecutorDocExists;
